<template>
    <div>
        <div></div>
        <form v-on:submit.prevent class="w-100 d-md-inline-block py-2">
            <div class="input-group mb-3 select-artcl-desg">
                <span class="text-gray" style="position: absolute; z-index: 20; margin-left: 10px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M8.75033 15.8337C12.6624 15.8337 15.8337 12.6624 15.8337 8.75033C15.8337 4.83824 12.6624 1.66699 8.75033 1.66699C4.83824 1.66699 1.66699 4.83824 1.66699 8.75033C1.66699 12.6624 4.83824 15.8337 8.75033 15.8337Z"
                            stroke="#7B8289"
                            stroke-width="1.5"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M11.1077 5.97625C10.7985 5.66627 10.4311 5.42044 10.0266 5.2529C9.6221 5.08536 9.18847 4.99942 8.75064 5C8.31281 4.99942 7.87918 5.08536 7.47467 5.2529C7.07016 5.42044 6.70275 5.66627 6.39355 5.97625M13.8431 13.8425L17.3786 17.3779"
                            stroke="#7B8289"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </span>
                <input
                    type="text"
                    class="form-control rounded-12"
                    :placeholder="$t('checkout.cart.select_article')"
                    id="search"
                    name="search"
                    v-model="researchValue"
                    @input="searchInput"
                    style="padding-left: 35px"
                />
            </div>
        </form>
        <div class="d-flex justify-content-between align-items-center">
            <ol class="breadcrumb breadcrumb-alt">
                <li @click="rollback(val, index)" v-for="(val, index) of breadcrumb" :key="index" class="breadcrumb-item">
                    <a class="link-fx" href="javascript:void(0)">{{ getCategoryLabel(val.name) }}</a>
                </li>
            </ol>
        </div>
        <v-app style="height: 4px; background-color: transparent">
            <v-progress-linear v-if="loading" indeterminate color="#3E4254"></v-progress-linear>
        </v-app>
        <!-- <v-progress-linear indeterminate color="yellow darken-2" style="width: 100%"></v-progress-linear> -->

        <!-- Category -->
        <div class="mt-1" v-if="showCategories">
            <!-- Categories 'Type Object' - Catégories -->
            <div v-if="!Array.isArray(actualCards)" class="row items-push">
                <div
                    v-for="(value, name) in actualCardsWithoutColor"
                    :key="name"
                    @click="nextStep(value, name, value?.id)"
                    class="col-lg-4 col-md-5 col-4"
                >
                    <div class="rounded-12 h-100 mb-0 ratio ratio-1x1 card" role="button">
                        <div class="d-flex flex-column justify-content-center align-items-center py-3 px-1">
                            <div
                                class="box-icon smallIcon ppv2-transition-all ppv2-duration-300"
                                :style="
                                    hasCustomColor(value)
                                        ? `background-color: ${getCustomColor(value)} !important `
                                        : 'background-color: #f8fafc !important; border-color: #e2e8f0 !important;'
                                "
                            >
                                <svg
                                    v-if="name == 'Activité'"
                                    id="prestations"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="33"
                                    viewBox="0 0 32 33"
                                >
                                    <path
                                        d="M14.2773 19.2386L11.7 29.9986C11.6671 30.1551 11.5871 30.2778 11.46 30.3666C11.3329 30.4555 11.188 30.5 11.0253 30.5C10.8031 30.5 10.6227 30.4231 10.484 30.2693C10.3462 30.1155 10.3045 29.9302 10.3587 29.7133L14.1187 11.2386L10.18 12.8386V16.4746C10.18 16.664 10.116 16.8222 9.98801 16.9493C9.86001 17.0764 9.70179 17.1404 9.51335 17.1413C9.32312 17.1413 9.16446 17.0773 9.03735 16.9493C8.91023 16.8213 8.84668 16.6631 8.84668 16.4746V12.664C8.84668 12.4489 8.90579 12.2529 9.02401 12.076C9.14312 11.8982 9.29912 11.7626 9.49201 11.6693L14.7587 9.44264C15.0698 9.30931 15.3631 9.22753 15.6387 9.19731C15.9151 9.1662 16.1836 9.18087 16.444 9.24131C16.7036 9.30087 16.9382 9.40931 17.148 9.56664C17.3569 9.72398 17.5418 9.93287 17.7027 10.1933L18.6253 11.66C18.9996 12.2573 19.4111 12.7986 19.86 13.284C20.3089 13.7702 20.7862 14.192 21.292 14.5493C21.7062 14.8462 22.1449 15.0884 22.608 15.276C23.0702 15.4626 23.5502 15.6066 24.048 15.708C24.2329 15.74 24.3822 15.8244 24.496 15.9613C24.6098 16.0964 24.6667 16.2591 24.6667 16.4493C24.6667 16.6386 24.5973 16.7915 24.4587 16.908C24.32 17.0235 24.156 17.068 23.9667 17.0413C22.6538 16.812 21.4689 16.3249 20.412 15.58C19.3542 14.8342 18.4418 13.8595 17.6747 12.656L16.456 18.756L19.036 21.4586C19.1347 21.5751 19.2089 21.6951 19.2587 21.8186C19.3085 21.9431 19.3333 22.0769 19.3333 22.22V29.8333C19.3333 30.0226 19.2698 30.1813 19.1427 30.3093C19.0147 30.4364 18.856 30.5 18.6667 30.5C18.4773 30.5 18.3187 30.4364 18.1907 30.3093C18.0636 30.1813 18 30.0226 18 29.8333V22.68L14.2773 19.2386ZM18 7.42264C17.3689 7.42264 16.8351 7.20442 16.3987 6.76798C15.9622 6.33153 15.744 5.79776 15.744 5.16664C15.744 4.53553 15.9622 4.00176 16.3987 3.56531C16.8351 3.12887 17.3689 2.91064 18 2.91064C18.6311 2.91064 19.1649 3.12887 19.6013 3.56531C20.0378 4.00176 20.256 4.53553 20.256 5.16664C20.256 5.79776 20.0378 6.33153 19.6013 6.76798C19.1649 7.20442 18.6311 7.42264 18 7.42264Z"
                                        fill="#94A3B8"
                                    />
                                </svg>
                                <svg
                                    v-if="['Bons cadeaux', 'Bons cadeau', 'Billet non daté'].includes(name)"
                                    id="bons_cadeau"
                                    data-name="bons cadeaux"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="33"
                                    viewBox="0 0 32 33"
                                    fill="none"
                                >
                                    <path
                                        d="M27 9.49979H22.615C22.6637 9.45854 22.7137 9.41854 22.7612 9.37479C23.1409 9.03751 23.4468 8.62553 23.66 8.16461C23.8731 7.70368 23.9889 7.20374 24 6.69604C24.0164 6.14063 23.9191 5.58773 23.7142 5.07128C23.5092 4.55482 23.2008 4.08571 22.8079 3.69275C22.4151 3.29979 21.9461 2.99126 21.4297 2.78612C20.9133 2.58097 20.3604 2.48354 19.805 2.49979C19.2971 2.51073 18.7969 2.6264 18.3358 2.83955C17.8746 3.0527 17.4624 3.35875 17.125 3.73854C16.6581 4.27966 16.2785 4.89034 16 5.54854C15.7215 4.89034 15.3419 4.27966 14.875 3.73854C14.5376 3.35875 14.1254 3.0527 13.6642 2.83955C13.2031 2.6264 12.7029 2.51073 12.195 2.49979C11.6396 2.48354 11.0867 2.58097 10.5703 2.78612C10.0539 2.99126 9.58491 3.29979 9.19206 3.69275C8.79922 4.08571 8.49083 4.55482 8.28584 5.07128C8.08085 5.58773 7.98358 6.14063 8 6.69604C8.01111 7.20374 8.12686 7.70368 8.34001 8.16461C8.55315 8.62553 8.85911 9.03751 9.23875 9.37479C9.28625 9.41604 9.33625 9.45604 9.385 9.49979H5C4.46957 9.49979 3.96086 9.71051 3.58579 10.0856C3.21071 10.4607 3 10.9694 3 11.4998V15.4998C3 16.0302 3.21071 16.5389 3.58579 16.914C3.96086 17.2891 4.46957 17.4998 5 17.4998V25.4998C5 26.0302 5.21071 26.5389 5.58579 26.914C5.96086 27.2891 6.46957 27.4998 7 27.4998H25C25.5304 27.4998 26.0391 27.2891 26.4142 26.914C26.7893 26.5389 27 26.0302 27 25.4998V17.4998C27.5304 17.4998 28.0391 17.2891 28.4142 16.914C28.7893 16.5389 29 16.0302 29 15.4998V11.4998C29 10.9694 28.7893 10.4607 28.4142 10.0856C28.0391 9.71051 27.5304 9.49979 27 9.49979ZM18.625 5.06354C18.7833 4.88869 18.9761 4.74847 19.1912 4.65167C19.4063 4.55487 19.6391 4.50359 19.875 4.50104H19.9363C20.2127 4.50277 20.486 4.55966 20.7402 4.66838C20.9944 4.7771 21.2244 4.93546 21.4166 5.13419C21.6088 5.33291 21.7594 5.568 21.8596 5.82567C21.9597 6.08335 22.0075 6.35843 22 6.63479C21.9975 6.87066 21.9462 7.10346 21.8494 7.31857C21.7526 7.53368 21.6123 7.72646 21.4375 7.88479C20.2512 8.93479 18.2825 9.30479 17.0625 9.43479C17.2125 8.11104 17.625 6.18729 18.625 5.06354ZM10.6138 5.10854C11.0012 4.72115 11.5259 4.50238 12.0737 4.49979H12.135C12.3709 4.50234 12.6037 4.55362 12.8188 4.65042C13.0339 4.74722 13.2267 4.88744 13.385 5.06229C14.4338 6.24729 14.8038 8.21229 14.9338 9.42729C13.7188 9.30229 11.7537 8.92729 10.5688 7.87854C10.3939 7.72021 10.2537 7.52743 10.1569 7.31232C10.0601 7.09721 10.0088 6.86441 10.0063 6.62854C9.9985 6.34759 10.0479 6.06798 10.1515 5.8067C10.255 5.54541 10.4106 5.30789 10.6088 5.10854H10.6138ZM5 11.4998H15V15.4998H5V11.4998ZM7 17.4998H15V25.4998H7V17.4998ZM25 25.4998H17V17.4998H25V25.4998ZM27 15.4998H17V11.4998H27V15.4998Z"
                                        fill="#94A3B8"
                                    />
                                </svg>
                                <svg
                                    v-if="name == 'Montant fixe'"
                                    id="bons_cadeau_montant_fixe"
                                    data-name="bons cadeau"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="33"
                                    viewBox="0 0 32 33"
                                    fill="none"
                                >
                                    <path
                                        d="M27 9.49979H22.615C22.6637 9.45854 22.7137 9.41854 22.7612 9.37479C23.1409 9.03751 23.4468 8.62553 23.66 8.16461C23.8731 7.70368 23.9889 7.20374 24 6.69604C24.0164 6.14063 23.9191 5.58773 23.7142 5.07128C23.5092 4.55482 23.2008 4.08571 22.8079 3.69275C22.4151 3.29979 21.9461 2.99126 21.4297 2.78612C20.9133 2.58097 20.3604 2.48354 19.805 2.49979C19.2971 2.51073 18.7969 2.6264 18.3358 2.83955C17.8746 3.0527 17.4624 3.35875 17.125 3.73854C16.6581 4.27966 16.2785 4.89034 16 5.54854C15.7215 4.89034 15.3419 4.27966 14.875 3.73854C14.5376 3.35875 14.1254 3.0527 13.6642 2.83955C13.2031 2.6264 12.7029 2.51073 12.195 2.49979C11.6396 2.48354 11.0867 2.58097 10.5703 2.78612C10.0539 2.99126 9.58491 3.29979 9.19206 3.69275C8.79922 4.08571 8.49083 4.55482 8.28584 5.07128C8.08085 5.58773 7.98358 6.14063 8 6.69604C8.01111 7.20374 8.12686 7.70368 8.34001 8.16461C8.55315 8.62553 8.85911 9.03751 9.23875 9.37479C9.28625 9.41604 9.33625 9.45604 9.385 9.49979H5C4.46957 9.49979 3.96086 9.71051 3.58579 10.0856C3.21071 10.4607 3 10.9694 3 11.4998V15.4998C3 16.0302 3.21071 16.5389 3.58579 16.914C3.96086 17.2891 4.46957 17.4998 5 17.4998V25.4998C5 26.0302 5.21071 26.5389 5.58579 26.914C5.96086 27.2891 6.46957 27.4998 7 27.4998H25C25.5304 27.4998 26.0391 27.2891 26.4142 26.914C26.7893 26.5389 27 26.0302 27 25.4998V17.4998C27.5304 17.4998 28.0391 17.2891 28.4142 16.914C28.7893 16.5389 29 16.0302 29 15.4998V11.4998C29 10.9694 28.7893 10.4607 28.4142 10.0856C28.0391 9.71051 27.5304 9.49979 27 9.49979ZM18.625 5.06354C18.7833 4.88869 18.9761 4.74847 19.1912 4.65167C19.4063 4.55487 19.6391 4.50359 19.875 4.50104H19.9363C20.2127 4.50277 20.486 4.55966 20.7402 4.66838C20.9944 4.7771 21.2244 4.93546 21.4166 5.13419C21.6088 5.33291 21.7594 5.568 21.8596 5.82567C21.9597 6.08335 22.0075 6.35843 22 6.63479C21.9975 6.87066 21.9462 7.10346 21.8494 7.31857C21.7526 7.53368 21.6123 7.72646 21.4375 7.88479C20.2512 8.93479 18.2825 9.30479 17.0625 9.43479C17.2125 8.11104 17.625 6.18729 18.625 5.06354ZM10.6138 5.10854C11.0012 4.72115 11.5259 4.50238 12.0737 4.49979H12.135C12.3709 4.50234 12.6037 4.55362 12.8188 4.65042C13.0339 4.74722 13.2267 4.88744 13.385 5.06229C14.4338 6.24729 14.8038 8.21229 14.9338 9.42729C13.7188 9.30229 11.7537 8.92729 10.5688 7.87854C10.3939 7.72021 10.2537 7.52743 10.1569 7.31232C10.0601 7.09721 10.0088 6.86441 10.0063 6.62854C9.9985 6.34759 10.0479 6.06798 10.1515 5.8067C10.255 5.54541 10.4106 5.30789 10.6088 5.10854H10.6138ZM5 11.4998H15V15.4998H5V11.4998ZM7 17.4998H15V25.4998H7V17.4998ZM25 25.4998H17V17.4998H25V25.4998ZM27 15.4998H17V11.4998H27V15.4998Z"
                                        fill="#94A3B8"
                                    />
                                </svg>
                                <svg
                                    v-if="name == 'Produits'"
                                    id="produits"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="33"
                                    viewBox="0 0 32 33"
                                    fill="none"
                                >
                                    <path
                                        d="M15 2.375L28 8.875V25.125L15 31.6094L2 25.125V8.875L15 2.375ZM24.7656 9.5L15 4.625L11.2344 6.5L20.9375 11.4062L24.7656 9.5ZM15 14.375L18.7188 12.5312L9 7.625L5.23438 9.5L15 14.375ZM4 11.125V23.875L14 28.875V16.125L4 11.125ZM16 28.875L26 23.875V11.125L16 16.125V28.875Z"
                                        fill="#94A3B8"
                                    />
                                </svg>
                                <svg
                                    v-if="name == 'Forfaits'"
                                    id="forfaits"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="33"
                                    viewBox="0 0 32 33"
                                    fill="none"
                                >
                                    <path
                                        d="M4.91267 19.7212L25.416 16.0439L29 9.94856L23.5033 5.97656L3 9.65323L4.91267 19.7212Z"
                                        stroke="#94A3B8"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M6.99609 19.3481L12.3274 27.0234L28.0088 16.5367L29.0001 9.94873"
                                        stroke="#94A3B8"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M24.726 11.37C25.1205 11.37 25.4403 11.0502 25.4403 10.6557C25.4403 10.2612 25.1205 9.94141 24.726 9.94141C24.3315 9.94141 24.0117 10.2612 24.0117 10.6557C24.0117 11.0502 24.3315 11.37 24.726 11.37Z"
                                        fill="#94A3B8"
                                    />
                                </svg>
                                <svg
                                    v-if="name == 'Wallet'"
                                    id="wallet"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="33"
                                    viewBox="0 0 32 33"
                                    fill="none"
                                >
                                    <path
                                        d="M25.3334 16.4998C25.3334 16.8535 25.1929 17.1926 24.9429 17.4426C24.6928 17.6927 24.3537 17.8332 24.0001 17.8332C23.6465 17.8332 23.3073 17.6927 23.0573 17.4426C22.8072 17.1926 22.6667 16.8535 22.6667 16.4998C22.6667 16.1462 22.8072 15.8071 23.0573 15.557C23.3073 15.307 23.6465 15.1665 24.0001 15.1665C24.3537 15.1665 24.6928 15.307 24.9429 15.557C25.1929 15.8071 25.3334 16.1462 25.3334 16.4998Z"
                                        fill="#94A3B8"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M13.2587 4.8335H17.4081C19.8587 4.8335 21.8001 4.8335 23.3187 5.0375C24.8814 5.24816 26.1467 5.69083 27.1454 6.68816C28.3774 7.9215 28.7707 9.57216 28.9134 11.7148C29.6827 12.0522 30.2641 12.7682 30.3267 13.6748C30.3334 13.7562 30.3334 13.8428 30.3334 13.9228V19.0775C30.3334 19.1575 30.3334 19.2442 30.3281 19.3242C30.2641 20.2308 29.6827 20.9482 28.9134 21.2868C28.7707 23.4282 28.3774 25.0788 27.1454 26.3122C26.1467 27.3095 24.8814 27.7522 23.3187 27.9628C21.7987 28.1668 19.8587 28.1668 17.4081 28.1668H13.2587C10.8081 28.1668 8.86675 28.1668 7.34808 27.9628C5.78542 27.7522 4.52008 27.3095 3.52141 26.3122C2.52408 25.3135 2.08141 24.0482 1.87075 22.4855C1.66675 20.9655 1.66675 19.0255 1.66675 16.5748V16.4255C1.66675 13.9748 1.66675 12.0335 1.87075 10.5148C2.08141 8.95216 2.52408 7.68683 3.52141 6.68816C4.52008 5.69083 5.78542 5.24816 7.34808 5.0375C8.86808 4.8335 10.8081 4.8335 13.2587 4.8335ZM26.8907 21.5002H24.3067C21.4467 21.5002 18.9987 19.3295 18.9987 16.5002C18.9987 13.6708 21.4467 11.5002 24.3054 11.5002H26.8894C26.7374 9.71216 26.3948 8.76683 25.7294 8.10283C25.1654 7.53883 24.3921 7.20016 23.0507 7.02016C21.6814 6.83616 19.8747 6.8335 17.3321 6.8335H13.3321C10.7894 6.8335 8.98408 6.83616 7.61208 7.02016C6.27208 7.20016 5.49875 7.53883 4.93475 8.10283C4.37075 8.66683 4.03208 9.44016 3.85208 10.7815C3.66808 12.1522 3.66541 13.9575 3.66541 16.5002C3.66541 19.0428 3.66808 20.8482 3.85208 22.2202C4.03208 23.5602 4.37075 24.3335 4.93475 24.8975C5.49875 25.4615 6.27208 25.8002 7.61341 25.9802C8.98408 26.1642 10.7894 26.1668 13.3321 26.1668H17.3321C19.8747 26.1668 21.6814 26.1642 23.0521 25.9802C24.3921 25.8002 25.1654 25.4615 25.7294 24.8975C26.3948 24.2335 26.7387 23.2895 26.8907 21.5002ZM7.00008 11.1668C7.00008 10.9016 7.10544 10.6473 7.29297 10.4597C7.48051 10.2722 7.73487 10.1668 8.00008 10.1668H13.3334C13.5986 10.1668 13.853 10.2722 14.0405 10.4597C14.2281 10.6473 14.3334 10.9016 14.3334 11.1668C14.3334 11.432 14.2281 11.6864 14.0405 11.8739C13.853 12.0615 13.5986 12.1668 13.3334 12.1668H8.00008C7.73487 12.1668 7.48051 12.0615 7.29297 11.8739C7.10544 11.6864 7.00008 11.432 7.00008 11.1668ZM27.8987 13.5002H24.3067C22.4081 13.5002 20.9987 14.9122 20.9987 16.5002C20.9987 18.0882 22.4081 19.5002 24.3054 19.5002H27.9294C28.2041 19.4828 28.3228 19.2975 28.3321 19.1855V13.8148C28.3228 13.7028 28.2041 13.5175 27.9294 13.5015H27.8974L27.8987 13.5002Z"
                                        fill="#94A3B8"
                                    />
                                </svg>
                                <svg
                                    v-if="name == 'Wallet Montant fixe'"
                                    id="Wallet-Montant-fixe"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="33"
                                    viewBox="0 0 32 33"
                                    fill="none"
                                >
                                    <path
                                        d="M25.3334 16.4998C25.3334 16.8535 25.1929 17.1926 24.9429 17.4426C24.6928 17.6927 24.3537 17.8332 24.0001 17.8332C23.6465 17.8332 23.3073 17.6927 23.0573 17.4426C22.8072 17.1926 22.6667 16.8535 22.6667 16.4998C22.6667 16.1462 22.8072 15.8071 23.0573 15.557C23.3073 15.307 23.6465 15.1665 24.0001 15.1665C24.3537 15.1665 24.6928 15.307 24.9429 15.557C25.1929 15.8071 25.3334 16.1462 25.3334 16.4998Z"
                                        fill="#94A3B8"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M13.2587 4.8335H17.4081C19.8587 4.8335 21.8001 4.8335 23.3187 5.0375C24.8814 5.24816 26.1467 5.69083 27.1454 6.68816C28.3774 7.9215 28.7707 9.57216 28.9134 11.7148C29.6827 12.0522 30.2641 12.7682 30.3267 13.6748C30.3334 13.7562 30.3334 13.8428 30.3334 13.9228V19.0775C30.3334 19.1575 30.3334 19.2442 30.3281 19.3242C30.2641 20.2308 29.6827 20.9482 28.9134 21.2868C28.7707 23.4282 28.3774 25.0788 27.1454 26.3122C26.1467 27.3095 24.8814 27.7522 23.3187 27.9628C21.7987 28.1668 19.8587 28.1668 17.4081 28.1668H13.2587C10.8081 28.1668 8.86675 28.1668 7.34808 27.9628C5.78542 27.7522 4.52008 27.3095 3.52141 26.3122C2.52408 25.3135 2.08141 24.0482 1.87075 22.4855C1.66675 20.9655 1.66675 19.0255 1.66675 16.5748V16.4255C1.66675 13.9748 1.66675 12.0335 1.87075 10.5148C2.08141 8.95216 2.52408 7.68683 3.52141 6.68816C4.52008 5.69083 5.78542 5.24816 7.34808 5.0375C8.86808 4.8335 10.8081 4.8335 13.2587 4.8335ZM26.8907 21.5002H24.3067C21.4467 21.5002 18.9987 19.3295 18.9987 16.5002C18.9987 13.6708 21.4467 11.5002 24.3054 11.5002H26.8894C26.7374 9.71216 26.3948 8.76683 25.7294 8.10283C25.1654 7.53883 24.3921 7.20016 23.0507 7.02016C21.6814 6.83616 19.8747 6.8335 17.3321 6.8335H13.3321C10.7894 6.8335 8.98408 6.83616 7.61208 7.02016C6.27208 7.20016 5.49875 7.53883 4.93475 8.10283C4.37075 8.66683 4.03208 9.44016 3.85208 10.7815C3.66808 12.1522 3.66541 13.9575 3.66541 16.5002C3.66541 19.0428 3.66808 20.8482 3.85208 22.2202C4.03208 23.5602 4.37075 24.3335 4.93475 24.8975C5.49875 25.4615 6.27208 25.8002 7.61341 25.9802C8.98408 26.1642 10.7894 26.1668 13.3321 26.1668H17.3321C19.8747 26.1668 21.6814 26.1642 23.0521 25.9802C24.3921 25.8002 25.1654 25.4615 25.7294 24.8975C26.3948 24.2335 26.7387 23.2895 26.8907 21.5002ZM7.00008 11.1668C7.00008 10.9016 7.10544 10.6473 7.29297 10.4597C7.48051 10.2722 7.73487 10.1668 8.00008 10.1668H13.3334C13.5986 10.1668 13.853 10.2722 14.0405 10.4597C14.2281 10.6473 14.3334 10.9016 14.3334 11.1668C14.3334 11.432 14.2281 11.6864 14.0405 11.8739C13.853 12.0615 13.5986 12.1668 13.3334 12.1668H8.00008C7.73487 12.1668 7.48051 12.0615 7.29297 11.8739C7.10544 11.6864 7.00008 11.432 7.00008 11.1668ZM27.8987 13.5002H24.3067C22.4081 13.5002 20.9987 14.9122 20.9987 16.5002C20.9987 18.0882 22.4081 19.5002 24.3054 19.5002H27.9294C28.2041 19.4828 28.3228 19.2975 28.3321 19.1855V13.8148C28.3228 13.7028 28.2041 13.5175 27.9294 13.5015H27.8974L27.8987 13.5002Z"
                                        fill="#94A3B8"
                                    />
                                </svg>
                                <svg
                                    v-if="name == 'Abonnements'"
                                    id="abonnements"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="33"
                                    viewBox="0 0 32 33"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_3549_71136)">
                                        <path
                                            d="M7.88789 2.24362C7.45039 2.39362 7.15039 2.64987 6.91289 3.06237C6.73789 3.36862 6.71914 3.46862 6.70039 4.04362L6.67539 4.68737H4.00664C1.35039 4.68737 1.34414 4.68737 1.03164 4.83737C0.662891 5.00612 0.362891 5.28737 0.169141 5.64987C0.0378906 5.89362 0.0316406 5.98112 0.0128906 7.91862L-0.00585938 9.93737L0.150391 10.0936C0.337891 10.2811 0.556641 10.2936 0.756641 10.1311L0.906641 10.0124L0.937891 8.03112L0.969141 6.04987L1.20039 5.83737L1.43789 5.62487H4.06289H6.68789V8.31237V10.9999H4.94414C3.24414 10.9999 3.20039 10.9999 3.00039 11.1436C2.61914 11.3999 2.53164 11.6311 2.53164 12.4061C2.53164 13.1811 2.60039 13.3874 2.95039 13.6374C3.15039 13.7811 3.18789 13.7811 4.92539 13.7999L6.68789 13.8186V14.2811V14.7499H4.46289H2.23789L2.05039 14.9374C1.90039 15.0936 1.86914 15.1624 1.90039 15.2999C1.92539 15.3936 2.00039 15.5186 2.07539 15.5749C2.18789 15.6749 2.40039 15.6874 4.44414 15.6874H6.68789V16.4999V17.3124H4.41914C1.91289 17.3124 2.00664 17.2999 1.90664 17.6999C1.86914 17.8374 1.90039 17.9061 2.05039 18.0624L2.23789 18.2499H4.46289H6.68789V19.0311V19.8124H4.50664C3.30664 19.8124 2.25039 19.8374 2.16914 19.8686C1.85039 19.9936 1.81914 20.5249 2.11914 20.6811C2.20039 20.7249 3.01914 20.7499 4.46289 20.7499H6.68789V21.5624V22.3749H5.13164C3.62539 22.3749 3.57539 22.3811 3.37539 22.5186C2.99414 22.7749 2.90664 23.0061 2.90664 23.7811C2.90664 24.3874 2.92539 24.4936 3.05039 24.6999C3.13164 24.8311 3.30039 24.9811 3.46289 25.0561C3.70664 25.1749 3.83789 25.1874 5.20664 25.1874H6.68789V26.2811V27.3749H4.06914C1.51289 27.3749 1.45039 27.3749 1.28789 27.2436C0.919141 26.9499 0.937891 27.4311 0.937891 19.2811V11.8061L0.781641 11.6561C0.587891 11.4561 0.350391 11.4561 0.150391 11.6561L0.000390625 11.8061L0.0128906 19.4499L0.0316406 27.0936L0.169141 27.3499C0.362891 27.7124 0.662891 27.9936 1.03164 28.1624C1.34414 28.3124 1.35039 28.3124 4.00664 28.3124H6.67539L6.70039 28.9561C6.71914 29.5311 6.73789 29.6311 6.91289 29.9374C7.01914 30.1249 7.22539 30.3749 7.36914 30.4811C7.90664 30.8936 7.47539 30.8749 16.0004 30.8749C24.5254 30.8749 24.0941 30.8936 24.6316 30.4811C24.7754 30.3749 24.9816 30.1249 25.0879 29.9374C25.2629 29.6311 25.2816 29.5311 25.3004 28.9561L25.3254 28.3186L28.0566 28.2999C30.5504 28.2811 30.8004 28.2686 31.0129 28.1686C31.3191 28.0124 31.6566 27.6749 31.8316 27.3561C31.9629 27.1061 31.9691 27.0186 31.9879 25.2749C32.0066 23.5624 32.0004 23.4499 31.8879 23.3124C31.7191 23.1061 31.3441 23.1061 31.1816 23.3061C31.0691 23.4374 31.0629 23.5811 31.0629 25.1061C31.0629 26.8936 31.0504 26.9811 30.7129 27.2436C30.5504 27.3749 30.4879 27.3749 27.9316 27.3749H25.3129V26.2811V25.1874H26.7941C28.1629 25.1874 28.2941 25.1749 28.5379 25.0561C28.7004 24.9811 28.8691 24.8311 28.9504 24.6999C29.0754 24.4936 29.0941 24.3874 29.0941 23.7811C29.0941 23.0061 29.0066 22.7749 28.6254 22.5186C28.4254 22.3811 28.3754 22.3749 26.8691 22.3749H25.3129V21.5624V20.7499H27.5379C28.9816 20.7499 29.8004 20.7249 29.8816 20.6811C30.1816 20.5249 30.1566 20.0249 29.8379 19.8811C29.7316 19.8374 28.9879 19.8124 27.5004 19.8124H25.3129V19.0311V18.2499H27.5379H29.7629L29.9504 18.0624C30.1004 17.9061 30.1316 17.8374 30.1004 17.6999C30.0754 17.6061 30.0004 17.4811 29.9254 17.4186C29.8129 17.3249 29.6004 17.3124 27.5566 17.3124H25.3129V16.4999V15.6874H27.5566C29.6004 15.6874 29.8129 15.6749 29.9254 15.5749C30.0004 15.5186 30.0754 15.3936 30.1004 15.2999C30.1316 15.1624 30.1004 15.0936 29.9504 14.9374L29.7629 14.7499H27.5379H25.3129V14.2811V13.8186L27.0816 13.7999C28.8129 13.7811 28.8504 13.7811 29.0504 13.6374C29.4004 13.3874 29.4691 13.1811 29.4691 12.4061C29.4691 11.6311 29.3816 11.3999 29.0004 11.1436C28.8004 10.9999 28.7566 10.9999 27.0566 10.9999H25.3129V8.31237V5.62487H27.9316C30.4879 5.62487 30.5504 5.62487 30.7129 5.75612C31.0816 6.04987 31.0629 5.54987 31.0629 13.8936C31.0629 21.5374 31.0629 21.5436 31.1941 21.7124C31.3691 21.9374 31.6941 21.9374 31.8691 21.7061L32.0004 21.5436L31.9879 13.7249L31.9691 5.90612L31.8254 5.64362C31.6504 5.30612 31.3379 4.99362 31.0254 4.83737C30.8004 4.72487 30.6066 4.71862 28.0566 4.69987L25.3254 4.68112L25.3004 4.04362C25.2816 3.46862 25.2629 3.36862 25.0879 3.06237C24.9816 2.87487 24.7754 2.62487 24.6316 2.51862C24.1066 2.11237 24.3129 2.12487 18.0879 2.12487H12.4441L12.2754 2.26862C12.0629 2.45612 12.0504 2.78737 12.2566 2.94987C12.3816 3.05612 12.7441 3.06237 18.0566 3.06237C23.4254 3.06237 23.7316 3.06862 23.9316 3.17487C24.0504 3.23737 24.2004 3.38737 24.2629 3.50612C24.3691 3.70612 24.3754 4.23737 24.3754 16.4874C24.3754 30.5249 24.4004 29.5249 24.0129 29.7936C23.8504 29.8999 23.4629 29.9061 16.0004 29.9061C8.53789 29.9061 8.15039 29.8999 7.98789 29.7936C7.60039 29.5249 7.62539 30.5249 7.62539 16.4874C7.62539 4.23737 7.63164 3.70612 7.73789 3.50612C7.95039 3.11237 8.13164 3.06237 9.41914 3.06237C10.4816 3.06237 10.5691 3.05612 10.6879 2.93737C10.8754 2.74987 10.8566 2.41862 10.6504 2.25612C10.4941 2.13112 10.4066 2.12487 9.35039 2.12487C8.41914 2.13112 8.16289 2.14987 7.88789 2.24362ZM6.68789 12.4061V12.8749L5.08164 12.8624L3.46914 12.8436L3.45039 12.3874L3.43164 11.9374H5.06289H6.68789V12.4061ZM28.5504 12.3874L28.5316 12.8436L26.9254 12.8624L25.3129 12.8749V12.4061V11.9374H26.9379H28.5691L28.5504 12.3874ZM6.68789 23.7811V24.2499L5.26914 24.2374L3.84414 24.2186L3.82539 23.7624L3.80664 23.3124H5.25039H6.68789V23.7811ZM28.1754 23.7624L28.1566 24.2186L26.7379 24.2374L25.3129 24.2499V23.7811V23.3124H26.7504H28.1941L28.1754 23.7624Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M15.7699 4.725C15.7262 4.74375 15.4949 5.0375 15.2512 5.38125C15.0012 5.71875 14.7824 6.0125 14.7574 6.025C14.7324 6.04375 14.3199 5.8875 13.8449 5.68125C12.8762 5.26875 12.6824 5.24375 12.4824 5.5125L12.3574 5.68125L12.6387 7.36875L12.9137 9.05625L12.7699 9.09375C12.3887 9.1875 12.2512 9.6125 12.5199 9.8625L12.6637 10H16.0074H19.3574L19.4887 9.85625C19.7387 9.5875 19.6074 9.1875 19.2324 9.09375L19.0887 9.05625L19.3637 7.36875L19.6449 5.68125L19.5199 5.5125C19.3199 5.24375 19.1262 5.26875 18.1637 5.68125C17.6887 5.89375 17.2762 6.04375 17.2512 6.03125C17.2199 6.0125 17.0012 5.71875 16.7574 5.38125C16.5137 5.04375 16.2699 4.74375 16.2137 4.725C16.1012 4.68125 15.8824 4.68125 15.7699 4.725ZM16.4324 6.53125C16.9199 7.2125 16.9512 7.21875 17.8199 6.85C18.2012 6.6875 18.5199 6.5625 18.5324 6.575C18.5512 6.59375 18.2262 8.625 18.1574 8.91875L18.1262 9.0625H16.0012H13.8762L13.8449 8.91875C13.7762 8.625 13.4512 6.59375 13.4699 6.575C13.4824 6.5625 13.8012 6.6875 14.1824 6.85C15.0574 7.21875 15.0824 7.2125 15.5824 6.5125C15.7887 6.225 15.9824 6.00625 16.0137 6.0125C16.0449 6.025 16.2387 6.25625 16.4324 6.53125Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M15.7009 7.59966C15.5197 7.72466 15.5072 8.11841 15.6884 8.28091C15.9759 8.54341 16.4384 8.34341 16.4384 7.95591C16.4384 7.56841 16.0322 7.36841 15.7009 7.59966Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M9.05652 11.1437C8.93777 11.2188 8.78152 11.4062 8.70027 11.5625C8.56902 11.8125 8.55652 11.9125 8.57527 12.4688C8.60027 13.175 8.68777 13.4062 9.01277 13.6375L9.21902 13.7812H16.0003H22.7815L22.9878 13.6375C23.3128 13.4062 23.4003 13.175 23.4253 12.4688C23.444 11.9125 23.4315 11.8125 23.3003 11.5625C23.219 11.4062 23.0628 11.2188 22.944 11.1437L22.7315 11H16.0003H9.26902L9.05652 11.1437ZM22.5003 12.4062V12.875H16.0003H9.50027V12.4062V11.9375H16.0003H22.5003V12.4062Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M10.1877 15.4187C9.86894 15.5375 9.76269 15.95 10.0002 16.1875C10.1189 16.3062 10.2064 16.3125 11.2752 16.3125H12.4314L12.5564 16.15C12.6314 16.0563 12.6877 15.9437 12.6877 15.9C12.6877 15.7188 12.5314 15.5 12.3564 15.4375C12.1689 15.375 10.3564 15.3562 10.1877 15.4187Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M13.9625 15.4375C13.8 15.5 13.625 15.7375 13.625 15.8813C13.625 15.9375 13.6812 16.0563 13.7562 16.15L13.8812 16.3125H17.8812C21.7937 16.3125 21.875 16.3125 22 16.1875C22.1687 16.0188 22.1625 15.6813 21.9937 15.525C21.8687 15.4125 21.7 15.4063 17.975 15.3938C15.8437 15.3875 14.0312 15.4063 13.9625 15.4375Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M10.0001 18.0622C9.81263 18.2497 9.83138 18.581 10.0439 18.7497C10.2064 18.8747 10.2689 18.881 11.3314 18.8622C12.4189 18.8435 12.4501 18.8372 12.5689 18.6935C12.7314 18.4935 12.7189 18.2747 12.5314 18.0935C12.3814 17.9372 12.3689 17.9372 11.2501 17.9372C10.2064 17.9372 10.1189 17.9435 10.0001 18.0622Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M13.7812 18.0938C13.6938 18.175 13.625 18.2875 13.625 18.3375C13.625 18.5125 13.7625 18.7375 13.9188 18.8062C14.025 18.8562 15.2313 18.875 17.9313 18.875C21.7438 18.875 21.8 18.875 21.9625 18.7437C22.1687 18.5812 22.1875 18.25 22 18.0625C21.875 17.9375 21.7937 17.9375 17.9062 17.9375H13.9313L13.7812 18.0938Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M10.0439 20.5625C9.83138 20.7312 9.81263 21.0625 10.0001 21.25C10.1189 21.3687 10.2064 21.375 11.2751 21.375H12.4314L12.5564 21.2125C12.7189 21.0062 12.7251 20.8062 12.5689 20.6187C12.4501 20.475 12.4189 20.4688 11.3314 20.45C10.2689 20.4312 10.2064 20.4375 10.0439 20.5625Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M13.9 20.5125C13.7625 20.575 13.625 20.8062 13.625 20.975C13.625 21.025 13.6938 21.1375 13.7812 21.2188L13.9313 21.375H17.9062C21.7937 21.375 21.875 21.375 22 21.25C22.1875 21.0625 22.1687 20.7312 21.9625 20.5687C21.8 20.4375 21.75 20.4375 17.9125 20.4437C15.375 20.4437 13.9875 20.4688 13.9 20.5125Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M10.0004 23.125C9.83168 23.2938 9.83793 23.6313 10.0067 23.7875C10.1254 23.8938 10.2629 23.9063 11.1692 23.925C12.2942 23.95 12.5004 23.9063 12.6192 23.65C12.7192 23.4313 12.7067 23.35 12.5567 23.1625L12.4317 23H11.2754C10.2067 23 10.1192 23.0063 10.0004 23.125Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M13.7568 23.1625C13.5881 23.3812 13.5943 23.5187 13.7756 23.7313L13.9256 23.9062H17.8943C21.7068 23.9062 21.8693 23.9 21.9943 23.7875C22.1631 23.6312 22.1693 23.2937 22.0006 23.125C21.8756 23 21.7943 23 17.8818 23H13.8818L13.7568 23.1625Z"
                                            fill="#94A3B8"
                                        />
                                        <path
                                            d="M12.3436 25.5874C12.1186 25.6874 11.8311 26.0062 11.7749 26.2187C11.7561 26.2999 11.7499 26.6687 11.7624 27.0437C11.7811 27.6187 11.7999 27.7499 11.9186 27.9124C12.2124 28.3187 12.1186 28.3124 16.0124 28.3124C19.9749 28.3124 19.8249 28.3312 20.1061 27.8374C20.2311 27.6249 20.2499 27.4999 20.2499 26.8999C20.2499 26.1374 20.1811 25.9499 19.7936 25.6624C19.6186 25.5312 19.5561 25.5312 16.0749 25.5187C13.2249 25.5062 12.4936 25.5187 12.3436 25.5874ZM19.3124 26.9062V27.3749H15.9999H12.6874V26.9062V26.4374H15.9999H19.3124V26.9062Z"
                                            fill="#94A3B8"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_3549_71136">
                                            <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <span
                                class="px-3 pt-lg-3 pt-sm-2 categoryName poppinsMedium"
                                :style="{ fontSize: normalizeFontSize(18) }"
                                >{{ getCategoryLabel(name) }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>

            <!-- Categories 'Type Array' - Sous-catégories -->
            <div v-else class="row my-2 items-push">
                <div
                    v-for="(value, index) of actualCardsWithoutColor"
                    :key="index"
                    @click="
                        !(isVoucher && ['booking', 'paintball'].includes(value.slug)) &&
                            nextStep(value, value.name, value.id, true)
                    "
                    class="col-4"
                >
                    <div
                        :class="{
                            'border-solid-1-gs w-100 h-100 rounded-12 card ppv2-bg-white dark:ppv2-bg-dark justify-content-center align-items-center py-4 m-1': true, // Always apply the 'ok' class
                            'disabled-div': isVoucher && ['booking', 'paintball'].includes(value.slug), // Conditional class
                        }"
                    >
                        <div
                            class="box-icon smallIcon ppv2-transition-all"
                            :style="
                                value.color
                                    ? `background-color: ${value.color}`
                                    : 'background-color: #f8fafc; border-color: #e2e8f0;'
                            "
                            role="button"
                        ></div>
                        <div class="my-2 d-flex justify-content-center align-items-center">
                            <p
                                class="mb-0 pt-lg-3 pt-sm-2 categoryName poppinsMedium"
                                :style="
                                    isVoucher && ['booking', 'paintball'].includes(value.slug) ? 'color: #cbd5e1 !important' : ''
                                "
                            >
                                {{ getCategoryLabel(value.name) }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Prestations & Produits -->
        <div v-else class="row items-push mt-0">
            <div v-if="noResults">
                <p class="noResText">{{ $t('checkout.cart.no_results_subcategory') }}</p>
            </div>
            <div class="noResText" v-if="!actualCardsWithoutColor.length && researchValue && !loading">
                {{ $t('checkout.cart.no_results_found') }}
            </div>
            <div v-for="(value, index) in actualCardsWithoutColor" :key="index" class="col-4 py-0">
                <form class="tooltip-container" :action="formAction" method="POST" ref="formPrestaAdd">
                    <input type="hidden" name="_token" :value="csrf" ref="_token" />
                    <input type="hidden" name="type" :value="currentCategory || value.cat" />
                    <input type="hidden" name="item_id" :value="value.id" />
                    <input v-if="orderId" type="hidden" name="order_id" :value="orderId" />
                    <input v-if="userId" type="hidden" name="user_id" :value="userId" />
                    <input
                        type="hidden"
                        id="priceModalPresta"
                        name="priceModalPresta"
                        :value="selectedOptionPriceByTimes ? selectedOptionPriceByTimes.price : value.price"
                        ref="priceModalPresta"
                    />
                    <input
                        v-if="currentCategory === 'Activité'"
                        type="hidden"
                        id="priceModalPrestaHT"
                        name="priceModalPrestaHT"
                        :value="selectedOptionPriceByTimes ? selectedOptionPriceByTimes.price_ht : value.price_ht"
                        ref="priceModalPrestaHT"
                    />
                    <p class="h6 imgName">{{ value.name }}</p>
                    <input type="hidden" id="prestationLabel" name="prestationLabel" :value="value.name" ref="prestationLabel" />
                    <input type="hidden" v-model="buttonClicked" name="buttonClicked" />
                    <input type="hidden" name="prestationPriceMain" :value="value.price" />
                    <input type="hidden" name="prestationPriceHtMain" :value="value.price_ht" />

                    <template v-if="!isVoucher">
                        <input type="hidden" name="price_ht" :value="value?.price_ht" />
                    </template>

                    <!-- bon cadeau -->
                    <template v-else>
                        <input type="hidden" name="type" :value="currentCategory" />
                        <input type="hidden" name="amount" :value="amount" />
                        <input type="hidden" name="bonCadeau" :value="true" />
                    </template>

                    <!-- Pour info => C'est du bricolage. Il est impératif de corriger cela dans les plus brefs délais! -->
                    <button type="submit" style="width: 100%" @click="setButtonClicked('mainButton')" :disabled="!canAddItems">
                        <div class="block block-rounded p-0">
                            <div class="block-content position-relative p-1 mb-2">
                                <span class="actPrice" style="position: absolute; top: 4px; left: 4px; z-index: 2"
                                    >{{ round(value.price, 2) }}{{ $symbolCurrency }}</span
                                >
                                <div class="options-container ppv2-rounded-xl ppv2-overflow-hidden">
                                    <img
                                        style="height: 110px; width: 100%; object-fit: cover"
                                        class="p-0 img-thumbnail options-item ppv2-border-0"
                                        v-if="value.img1"
                                        :src="value.img1 || '/media/default.png'"
                                        :alt="value.name"
                                    />
                                    <img
                                        style="height: 110px; width: 100%; object-fit: cover"
                                        class="p-0 img-thumbnail options-item ppv2-border-0"
                                        v-else
                                        :src="value.image || '/media/default.png'"
                                        :alt="value.name"
                                    />
                                </div>
                            </div>
                            <div class="d-flex flex-row justify-content-around align-items-center pt-0 mb-0">
                                <!-- #TODO Définir si l'on trie dans le controler les produit et prestations non vendable {{ value}} -->

                                <div class="d-flex flex-column align-items-center my-2">
                                    <p
                                        class="imgName poppinsSemiBold ppv2-text-sm line-clamp-2"
                                        style="height: 40px; overflow: hidden"
                                    >
                                        {{ value.name }}
                                    </p>
                                    <input
                                        type="hidden"
                                        id="prestationLabel"
                                        name="prestationLabel"
                                        :value="value.name"
                                        ref="prestationLabel"
                                    />
                                    <input
                                        type="hidden"
                                        id="quantity"
                                        name="quantity"
                                        onchange="this.form.submit()"
                                        class="input-number rounded-12 h-32"
                                        min="1"
                                        value="1"
                                        ref="quantity"
                                    />
                                </div>
                                <p v-if="isPrestation" class="ActTemp">{{ value.duration }} min</p>
                                <p v-if="isProduct" class="fs-14 mb-0 text-muted">
                                    {{ $t('checkout.cart.available_qty') }} {{ value.quantity }}
                                </p>
                                <input
                                    type="hidden"
                                    id="timeQty"
                                    name="timeQty"
                                    :value="selectedOptionPriceByTimes ? selectedOptionPriceByTimes.duration : value.duration"
                                    ref="timeQty"
                                />
                                <input
                                    type="hidden"
                                    id="priceByTimesId"
                                    name="priceByTimesId"
                                    :value="selectedOptionPriceByTimes?.id ?? 0"
                                />
                                <input
                                    type="hidden"
                                    id="priceByTimes"
                                    name="priceByTimes"
                                    :value="selectedOptionPriceByTimes?.price ?? 0"
                                />
                                <input type="hidden" id="prestaStatus" name="prestaStatus" value="1" ref="prestaStatus" />
                            </div>
                        </div>
                    </button>

                    <div
                        class="tooltip-prices pt-3"
                        v-if="isPrestation && value?.prices_by_times?.length > 0"
                        @mouseenter="isTooltipHovered = true"
                        @mouseleave="isTooltipHovered = false"
                    >
                        <h5 class="fs-base mb-2 ppv2-text-black fw-medium">{{ value.name }}</h5>
                        <div
                            class="form-check form-block"
                            v-for="(pricesByTimes, indexPricesByTimes) in value?.prices_by_times"
                            :key="indexPricesByTimes"
                        >
                            <input
                                type="radio"
                                class="form-check-input col-8"
                                :id="'price-by-time-' + indexPricesByTimes + index"
                                :name="'price-by-time-' + indexPricesByTimes"
                                :value="pricesByTimes"
                                v-model="selectedOptionPriceByTimes"
                            />
                            <label
                                class="form-check-label label-price-design"
                                :for="'price-by-time-' + indexPricesByTimes + index"
                            >
                                <span class="d-block fw-normal text-center">
                                    <span class="fs-14 ppv2-text-black fw-medium">{{
                                        getDuration(pricesByTimes.duration) +
                                        ' > ' +
                                        round(pricesByTimes.price, 2) +
                                        $symbolCurrency
                                    }}</span>
                                </span>
                            </label>
                        </div>

                        <input
                            type="number"
                            v-if="undatedTicket"
                            v-model="qtyUndatedTicket"
                            min="1"
                            name="qtyUndatedTicket"
                            class="form-control mt-2 mb-2 h-32"
                            @input="validateQtyUndatedTicket"
                        />

                        <!-- Pour info => C'est du bricolage. Il est impératif de corriger cela dans les plus brefs délais! -->
                        <BaseButton
                            type="submit"
                            variant="primary"
                            @click="setButtonClicked('validateButton')"
                            :disabled="isValidBtnDisabled || !canAddItems"
                            :customHeight="32"
                            :customFontSize="14"
                            customClass="!ppv2-min-w-[120px] !ppv2-py-1"
                        >
                            {{ $t('common.validate') }}
                        </BaseButton>
                    </div>
                </form>

                <div :id="{ 'modal-overlay': modalVoucher }"></div>
            </div>
        </div>
        <CustomDialog :value="fixedAmount" :defaultTitle="currentCategory" @cancel="closeVoucherModal">
            <template #content>
                <form :action="action" method="POST" ref="voucherForm">
                    <div class="block-content d-flex flex-column fs-sm mb-4 overflow-hidden">
                        <input type="hidden" name="_token" :value="csrf" ref="_token" />
                        <input type="hidden" name="type" :value="currentCategory" />
                        <input v-if="orderId" type="hidden" name="order_id" :value="orderId" />
                        <input v-if="userId" type="hidden" name="user_id" :value="userId" />
                        <input
                            type="hidden"
                            id="prestationLabel"
                            name="prestationLabel"
                            :value="currentCategory + 'de ' + amount + $symbolCurrency"
                            ref="prestationLabel"
                        />
                        <div class="row">
                            <div class="d-flex justify-content-center flex-wrap gap-3 my-2">
                                <SelectableList :options="amountOptions" v-model="amount" :inSameLine="true" />
                            </div>

                            <div class="col-md-6" :class="currentCategory == 'Wallet' ? 'd-none' : ''">
                                <CustomInput
                                    type="number"
                                    :label="$t('checkout.payment.quantity')"
                                    :placeholder="$t('checkout.voucher.errors.fill_required')"
                                    classInputAdd="input-number text-start w-100"
                                    :required="true"
                                    :min="1"
                                    v-model="quantity"
                                />
                                <input type="hidden" name="quantity" :value="quantity" />
                            </div>
                            <div class="col-md-6">
                                <CustomInput
                                    type="number"
                                    :label="
                                        $t('checkout.payment.amount_category', { category: getCategoryLabel(currentCategory) })
                                    "
                                    :placeholder="$t('checkout.voucher.errors.fill_required')"
                                    classInputAdd="text-start"
                                    :required="true"
                                    :min="1"
                                    step="0.01"
                                    v-model="amount"
                                />
                                <input type="hidden" name="amount" :value="amount" />
                                <input
                                    type="hidden"
                                    id="priceModalPresta"
                                    name="priceModalPresta"
                                    :value="amount"
                                    ref="priceModalPresta"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </template>
            <template #actions>
                <BaseButton
                    type="button"
                    variant="outline"
                    customClass="!ppv2-min-h-[40px] ppv2-bg-white dark:ppv2-bg-dark-popup"
                    @click="closeVoucherModal"
                >
                    {{ $t('common.close') }}
                </BaseButton>
                <BaseButton
                    type="button"
                    variant="primary"
                    customClass="!ppv2-min-h-[40px]"
                    @click="submitVoucherForm"
                    :disabled="!canAddItems"
                >
                    {{ $t('common.validate') }}
                </BaseButton>
            </template>
        </CustomDialog>
        <div v-if="modalVoucher" :class="{ show: modalVoucher }" class="modal-backdrop fade"></div>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize.js'
import normalizeFontSize from '../../utils/normalizeFontSize.js'

/*
 *   Categories:
 */

export default {
    props: [
        'prestaAdd',
        'voucherAdd',
        'walletAdd',
        'getPrestationsBySubcategory',
        'getPrestationsByVoucherSubcategory',
        'getProductsBySubcategory',
        'categories',
        'questions',
        'researchRoute',
        'currentCustomer',
        'userId',
        'orderId',
        'canCreateOrder',
        'canModifyOrder',
    ],
    name: 'checkout-component',
    components: {
        DialogAlerte: () => import('../Calendar/Modal/parts/DialogAlerte.vue'),
        CustomDialog: () => import('../Shared/CustomDialog.vue'),
        BaseButton: () => import('../Shared/BaseButton.vue'),
        CustomInput: () => import('../Inputs/CustomInput.vue'),
        SelectableList: () => import('../Shared/SelectableList.vue'),
    },
    data: () => ({
        breadcrumb: [],
        actualCards: null,
        showCategories: true,
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        isPrestation: false,
        isProduct: false,
        isSerie: false,
        isVoucher: false,
        undatedTicket: false,
        researchValue: '',
        currentCategory: null,
        noResults: false,
        lastRequest: new Date(),
        loading: false,
        timeout: null,
        alertRebooking: null,

        // Voucher Prestation modal
        modalVoucher: false,
        fixedAmount: false,
        amount: 1,
        action: '',
        selectedOptionPriceByTimes: '',
        buttonClicked: '',
        qtyUndatedTicket: 1,
        quantity: 1,
        isTooltipHovered: false,
    }),
    computed: {
        canAddItems() {
            const hasCreate = this.canCreateOrder === true || this.canCreateOrder === 'true'
            const hasModify = this.canModifyOrder === true || this.canModifyOrder === 'true'
            if (this.orderId && parseInt(this.orderId) !== 0) {
                return hasModify
            }
            return hasCreate
        },
        actualCardsWithoutColor: function () {
            if (Array.isArray(this.actualCards)) {
                return this.actualCards.filter((i) => typeof i !== 'string')
            }

            // we have only one category no need so to display it, directly show its sub-categories
            if (this.actualCards !== null && typeof this.actualCards === 'object') {
                let ol = Object.keys(this.actualCards ?? {}).length
                if (ol == 1) this.actualCards = Object.values(this.actualCards)[0].filter((i) => typeof i !== 'string')
            }
            return this.actualCards
        },
        formAction() {
            return this.isVoucher ? this.voucherAdd : this.prestaAdd
        },
        isValidBtnDisabled() {
            return this.selectedOptionPriceByTimes === '' || this.selectedOptionPriceByTimes === null ? true : false
        },
        amountOptions() {
            return [
                { value: 100, label: `100${this.$symbolCurrency}` },
                { value: 50, label: `50${this.$symbolCurrency}` },
                { value: 20, label: `20${this.$symbolCurrency}` },
                { value: 10, label: `10${this.$symbolCurrency}` },
            ]
        },
    },
    watch: {
        isTooltipHovered(newVal) {
            if (!newVal) {
                this.selectedOptionPriceByTimes = ''
                this.qtyUndatedTicket = 1
            }
        },
    },
    mounted() {
        this.actualCards = this.categories
    },
    methods: {
        normalizeSize,
        normalizeFontSize,
        getCategoryLabel(name) {
            const map = {
                Activité: 'checkout.categories.activity',
                Activite: 'checkout.categories.activity',
                Produits: 'checkout.categories.products',
                Abonnements: 'checkout.categories.subscriptions',
                'Bons cadeaux': 'checkout.categories.vouchers',
                'Bons cadeau': 'checkout.categories.vouchers',
                'Billet non daté': 'checkout.categories.undated_ticket',
                Forfaits: 'checkout.categories.bundles',
                Wallet: 'checkout.categories.wallet',
            }
            return map[name] ? this.$t(map[name]) : name
        },
        setButtonClicked(button) {
            this.buttonClicked = button
        },
        searchInput() {
            this.loading = true
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            this.timeout = setTimeout(() => {
                this.research()
                this.loading = false
            }, 500)
        },
        hasCustomColor(value) {
            return typeof value[value.length - 1] === 'string' && value[value.length - 1] !== ''
        },

        getCustomColor(value) {
            return value[value.length - 1]
        },
        rollback(val, index) {
            // console.log(val)
            if (val.name == 'Activité' || val.name == 'Activite') {
                this.isPrestation = false
                this.isProduct = false
            }
            this.isVoucher = false
            this.undatedTicket = false
            this.fixedAmount = false

            this.actualCards = val.previousCategory
            this.breadcrumb = this.breadcrumb.slice(0, index)
            this.showCategories = true
        },

        nextStep(event, name, id, isLastStep = false) {
            // Entering a fresh top-level category from the root grid: clear navigation flags
            // left over from a previously-browsed category. Without this, browsing "Produits"
            // leaves isProduct=true and clicking "Forfaits"/"Abonnements" (which set isLastStep)
            // wrongly triggers getProducts() and shows a vente-additionnelle item.
            if (this.breadcrumb.length === 0) {
                this.isPrestation = false
                this.isProduct = false
                this.isSerie = false
                this.isVoucher = false
                this.undatedTicket = false
            }
            switch (name) {
                case 'Activité':
                    if (this.breadcrumb.filter((e) => ['Bons cadeaux', 'Bons cadeau'].includes(e.name)).length > 0) {
                        this.isVoucher = true
                    }
                    if (this.breadcrumb.filter((e) => e.name === 'Billet non daté').length > 0) {
                        this.isVoucher = true
                        this.undatedTicket = true
                    }
                    this.currentCategory = name
                    this.isPrestation = true
                    break
                case 'Produits':
                    this.isProduct = true
                    this.currentCategory = name
                    break
                case 'Abonnements':
                    this.currentCategory = name
                    isLastStep = true
                    break
                // case 'Forfaits':
                //     this.currentCategory = name
                //     isLastStep = true
                //     break
                // case 'Bons cadeau':
                //     this.isVoucher = true
                //     this.currentCategory = name
                //     break
                case 'Billet non daté':
                    this.isVoucher = true
                    this.undatedTicket = true
                    this.currentCategory = name
                    break
                case 'Forfaits':
                    this.currentCategory = name
                    isLastStep = true
                    break
                case 'Bons cadeaux':
                case 'Bons cadeau':
                    isLastStep = true
                    this.isVoucher = true
                    this.fixedAmount = true
                    this.modalVoucher = true
                    this.currentCategory = name
                    this.action = this.voucherAdd
                    break
                case 'Wallet':
                    isLastStep = true
                    this.fixedAmount = true
                    this.modalVoucher = true
                    this.currentCategory = 'Wallet'
                    this.action = this.walletAdd
                    break

                default:
                    break
            }

            this.breadcrumb.push({ name: name, id: id, previousCategory: this.actualCards })
            this.actualCards = event

            if (isLastStep) {
                this.showCategories = false
                if (this.isPrestation) this.getPrestations(id)
                //if (this.isVoucher) this.getPrestationsVoucher(27)
                if (this.isProduct) this.getProducts(id)
            }
        },

        async research() {
            const targetDate = new Date()
            if (this.researchValue.length > 0) {
                this.loading = true
                axios
                    .get(this.researchRoute, { params: { name: this.researchValue, category: this.currentCategory } })
                    .then((res) => {
                        if (targetDate <= this.lastRequest) return

                        this.showCategories = false
                        this.actualCards = res.data
                        this.lastRequest = targetDate
                    })
                    .catch((error) => {
                        // console.log(error)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                this.showCategories = true
                this.currentCategory = null
                this.actualCards = this.categories
                this.breadcrumb.splice(0)
                this.lastRequest = targetDate
                // switch (this.currentCategory) {
                //   case 'Prestations':
                //     if (this.breadcrumb.filter(e => e.name === 'Bons cadeau').length > 0) {
                //       this.isVoucher = true
                //       console.log('voucher')
                //     }
                //     this.isPrestation = true
                //     this.actualCards = this.categories

                //     break
                //   case 'Produits':
                //     this.isProduct = true
                //     this.actualCards = this.categories
                //     break
                //   case 'Abonnements':
                //     this.showCategories = false
                //     break
                //   case 'Forfaits':
                //     this.showCategories = false
                //     break
                //   case 'Bons cadeau':
                //     this.isVoucher = true
                //     this.actualCards = this.categories
                //     break
                //   case 'Cures':
                //     this.showCategories = false
                //     break

                //   default:
                //     this.showCategories = true
                //     this.actualCards = this.categories
                //     break
                // }
            }
        },

        async getPrestations(subcategory) {
            axios
                .get(this.getPrestationsBySubcategory, {
                    params: {
                        id: subcategory,
                        isVoucher: this.undatedTicket || this.isVoucher ? 1 : -1,
                        undatedTicket: this.undatedTicket ? 1 : 0,
                    },
                })
                .then((res) => {
                    this.actualCards = res?.data?.data ?? res.data
                    if (res.data.length == 0) {
                        this.noResults = true
                    }
                })
                .catch((error) => {
                    // console.log(error)
                })
        },

        async getPrestationsVoucher(subcategory) {
            axios
                .get(this.getPrestationsByVoucherSubcategory, { params: { id: subcategory } })
                .then((res) => {
                    this.actualCards = res?.data?.data ?? res.data
                    if (res.data.length == 0) {
                        //this.noResults = true
                    }
                })
                .catch((error) => {
                    // console.log(error)
                })
        },

        async getProducts(subcategory) {
            axios
                .get(this.getProductsBySubcategory, { params: { id: subcategory } })
                .then((res) => {
                    this.actualCards = res.data
                    if (res.data.length == 0) {
                        this.noResults = true
                    }
                })
                .catch((error) => {
                    //   console.log(error)
                })
        },

        openVoucherModal(index) {
            this.$refs.modalVoucher[index].classList.remove('hide')
            this.$refs.modalVoucher[index].classList.add('show')
            this.$refs.modalVoucher[index].style.display = 'block'
            this.modalVoucher = true
        },

        closeVoucherModal(index = null) {
            this.modalVoucher = false
            this.isVoucher = false

            if (this.fixedAmount) {
                this.fixedAmount = false

                // Retour à l'affichage des catégories
                this.showCategories = true
                this.actualCards = this.categories
                this.breadcrumb = []
            } else {
                this.$refs.modalVoucher[index].classList.add('hide')
                this.$refs.modalVoucher[index].classList.remove('show')
                this.$refs.modalVoucher[index].style.display = 'none'
            }
        },

        modalSubmit(index) {
            this.$refs.formPrestaAdd[index].submit()
        },
        submitVoucherForm() {
            this.$refs.voucherForm.submit()
        },

        blockEnterKey(event) {
            // console.log(event)
            event.preventDefault()
            return false
        },
        setAmount(amount_passed) {
            //  console.log(amount_passed)
            this.amount = amount_passed
        },
        generateTitle(prices) {
            return prices
                .map((item) => {
                    const hours = Math.floor(item.duration / 60)
                    const minutes = item.duration % 60
                    if (item.duration > 0) {
                        if (item.duration > 30) {
                            return `${hours}h ${minutes > 0 ? minutes + 'm' : ''} => ${item.price} {{$symbolCurrency}}`
                        } else {
                            return `${item.duration}h => ${item.price} {{$symbolCurrency}}`
                        }
                    }
                    return null
                })
                .filter((title) => title !== null)
                .join('\n')
        },
        getDuration(duration) {
            if (duration <= 0) return
            const { formatDuration } = require('../../utils/duration')
            return formatDuration(duration, this.$i18n)
        },
        validateQtyUndatedTicket() {
            const value = Number(this.qtyUndatedTicket)

            if (isNaN(value) || value < 1) {
                this.qtyUndatedTicket = 1
            }
        },
        round(value, decimals) {
            if (!value) return 0
            return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
        },
    },
}
</script>

<style scoped>
input[type='number'] {
    -moz-appearance: none;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.v-application--wrap {
    flex: 1 1 auto;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    min-height: 20vh;
    max-width: 100%;
    position: relative;
}
.card {
    border: 1px solid var(--Strok, rgba(148, 163, 184, 0.2));
}
.card:hover {
    border: 1px solid #b7e1f8;
    background-color: #b7e1f83d;
    font-weight: bolder;
}

.card:hover .d-flex .box-icon {
    border: 1px solid #b7e1f8;
    background-color: #b7e1f83d;
}
.imgName {
    color: var(--Navy, var(--Navy, #021832));
    text-align: center;
    font-family: Poppins Regular;
    font-size: clamp(12px, 0.729545vw, 16px);
    margin-bottom: 0 !important;
}
.ActTemp {
    color: #94a3b8;
    text-align: center;
    font-family: Poppins Regular;
    font-size: clamp(12px, 0.729545vw, 16px);
    margin-bottom: 0 !important;
}
.categoryName {
    color: #94a3b8;
    text-align: center;
    font-family: Poppins Regular;
    line-height: normal;
    width: max-content;
    display: contents;
}
.box-icon {
    display: flex;
    width: 60px;
    height: 60px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 50%;
    border: 1px solid rgba(148, 163, 184, 0.1);
    background-color: #f8fafc;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.card:hover .box-icon {
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    border-color: #e2e8f0;
}
.noResText {
    color: var(--Grey, #94a3b8);
    font-family: Poppins Regular;
    font-size: 12px;
    line-height: normal;
    margin-top: 12px;
}

.tooltip-container {
    position: relative;
    display: inline-block;
    width: 100%;
}

.tooltip-prices {
    visibility: hidden;
    width: 200px;
    max-width: 300px;
    background-color: #fff;
    color: #0238;
    text-align: center;
    padding: 10px;
    border-radius: 13px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 9999999;
    box-shadow: 0px 0px 3px 1px #e2e8f0;
    transform: translate(-50%, 7%);
}
.dark .tooltip-prices {
    background-color: #141243;
    box-shadow:
        inset 0 0 36px #2b3362,
        0 14px 45px rgba(0, 0, 0, 0.5);
    color: #fff;
}
.tooltip-container:hover .tooltip-prices {
    visibility: visible;
}
.disabled-div {
    pointer-events: none !important;
    opacity: 0.5;
}

.h-32 {
    height: 38px !important;
}
</style>
